/**
 * Maps registration API validation errors to form field keys and user-facing
 * summary messages for RegisterUser and RegisterAdmin.
 */
const API_FIELD_MAP = {
  email: "email",
  username: "email",
  user: "email",
  User: "email",
  password: "password1",
  first_name: "first_name",
  last_name: "last_name",
  phone: "phone",
  company_name: "company_name",
  business_id: "business_id",
};

function firstErrorMessage(value) {
  if (Array.isArray(value)) {
    return typeof value[0] === "string" ? value[0] : null;
  }
  return typeof value === "string" ? value : null;
}

export function parseRegistrationApiErrors(apiError, t) {
  const data = apiError?.data;
  const statusCode = apiError?.status || 500;

  if (statusCode >= 500) {
    return {
      fieldErrors: {},
      message: t(
        "Rekisteröinti epäonnistui. Palvelinvirhe. Ota yhteys tarvittaessa ylläpitoon support@opentaxi.fi",
      ),
      statusCode,
    };
  }

  if (!data || typeof data !== "object") {
    return {
      fieldErrors: {},
      message: t(
        "Rekisteröinti epäonnistui. Yritä uudelleen tai ota yhteyttä tukeen support@opentaxi.fi",
      ),
      statusCode,
    };
  }

  const fieldErrors = {};
  let message = null;

  if (data.token) {
    message = t(
      "Kutsu on vanhentunut tai virheellinen. Pyydä uusi kutsu ylläpidolta.",
    );
  } else if (data.user || data.username || data.User) {
    message = t(
      "Sähköposti on jo rekisteröity palveluun. Asiakastilin voi poistaa menemällä mobiilisovelluksessa -> Omat tiedot -> Poista profiili. Ongelmatilanteissa ota yhteys tukeemme support@opentaxi.fi",
    );
  }

  Object.entries(data).forEach(([key, value]) => {
    const text = firstErrorMessage(value);
    if (!text) return;

    const field = API_FIELD_MAP[key];
    if (field) {
      fieldErrors[field] = text;
    }
  });

  if (!message) {
    if (Object.keys(fieldErrors).length > 0) {
      message = t("Tarkista korostetut kentät.");
    } else {
      message = t(
        "Rekisteröinti epäonnistui. Tarkista lomakkeen kentät. Jos ongelma jatkuu ota yhteyttä tukeemme support@opentaxi.fi",
      );
    }
  }

  return { fieldErrors, message, statusCode };
}
